import 'magnific-popup';
require( 'owl.carousel' );

import tour from './tour';

jQuery( document ).ready(function($) {
	//newsletter();
	tour();

  $('#header .hamburger').on('click', function (e) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.nav-container' ).toggleClass( 'active' );
		$( '#header .container' ).toggleClass( 'active' );
		$( '#header .logo' ).toggleClass( 'mobile' );
  });

  if ($('#header nav li.current-menu-item').length > 1) {
		$('#header nav li.current-menu-item').removeClass('current-menu-item');
	}

  $('#header nav a').on('click', function(event) {
		if (this.hash !== "") {
      //event.preventDefault();
      // Store hash
      var hash = this.hash;
      
      if (window.location.pathname != '/') {
        window.location = '/' + hash;
      }

			var pos = $(hash).offset().top - 80;
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: pos
      }, 800, function(){
    		window.location.hash = hash;
				scrollActiveNav(pos);
				$( '.nav-container' ).removeClass( 'active' );
				$( '#header .logo' ).removeClass( 'mobile' );
				$('#header .hamburger').removeClass( 'is-active' );
      });
    }
	});

	function scrollActiveNav(pos) {
    var header_height = $('#header').height() + 40;

		$('#header nav a').each(function(){
			var currLink = $(this);
			var href = currLink.attr('href');
			
			if (href.indexOf('#') != -1) {
				var hash = href.substring(href.indexOf('#'))
				var refElement = $(hash);

				if (refElement.length > 0) {
					if (refElement.position().top - header_height <= pos && refElement.position().top + refElement.outerHeight() - header_height > pos) {
							currLink.parent().addClass("current-menu-item");
					} else {
							currLink.parent().removeClass("current-menu-item");
					}
				}
			}
		});
  }

  $(window).on('scroll', function() {
    const pos = $(document).scrollTop();
    scrollActiveNav(pos)
  });

	scrollActiveNav($(document).scrollTop());
	
	$('.section-banner .slider').owlCarousel({
    items: 1,
    dotsEach: true,
    loop: false,
    nav: true,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>']
	});
	
	$('.section-music .slider').owlCarousel({
    items: 1,
    dotsEach: true,
    loop: false,
    nav: true,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>']
	});
	
	$('.section-videos .slider').owlCarousel({
    items: 1,
    dotsEach: true,
    loop: false,
    nav: true,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>'],
    onTranslated: function(e) {
      $('.section-videos .slider .owl-item:not(.active):not(.cloned) iframe').each(function(){
        $(this).attr('src', $(this).attr('src'));
      });
    }
	});
	
	$('.section-news .slider').owlCarousel({
    responsive : {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      768: {
        items: 3
      }
    },
    dotsEach: true,
    loop: false,
    nav: true,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>']
  });

  $('.section-about .action .btn').on( 'click', function ( e ) {
		e.preventDefault();
		$.magnificPopup.open( {
			items: {
				src: '.section-about .content',
				type: 'inline',
      },
      fixedContentPos: 'auto'
		} );
  });

  $('.btn-rdfam').on( 'click', function ( e ) {
    e.preventDefault();
		$.magnificPopup.open( {
			items: {
				src: '#rd-fam-modal',
				type: 'inline',
      },
      fixedContentPos: 'auto',
      mainClass: 'rdfam-wrapper'
		} );
  });

  $('.enter-site').on('click', function (e) {
    $('.pum-close').click();
  });
  
});
